import { render, staticRenderFns } from "./proposal.vue?vue&type=template&id=081a77de&scoped=true&"
import script from "./proposal.vue?vue&type=script&lang=js&"
export * from "./proposal.vue?vue&type=script&lang=js&"
import style0 from "./proposal.vue?vue&type=style&index=0&id=081a77de&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081a77de",
  null
  
)

export default component.exports